module.exports = __webpack_public_path__ + "img/hwdl13.d8990e02.jpg";